export default class Pagination {
  readonly page: number
  readonly perPage: number
  readonly totalPages: number
  readonly totalObjects: number

  constructor(data: { [key: string]: any }) {
    this.page = data.page || 1
    this.perPage = data.perPage || 1
    this.totalPages = data.totalPages || 1
    this.totalObjects = data.totalObjects || 1
  }
}
